module.exports = __webpack_public_path__ + "static/media/08_Timeline_atmo.76fdfa41.webp";